module.exports = __webpack_public_path__ + "static/media/sucursales.e73360d6.jpg";